// CURRENT CART

/** @return {object} -get main product */
const getCurrentCartProduct = state => {
  return state.currentCart.items;
};

/** @return {object} - get Coupon Code */
const getCurrentCartCouponCode = state => {
  return state.currentCart.couponCode;
};
/** @return {object} - get Error Messages */
const getCurrentCartErrorMessages = state => {
  return state.currentCart.errorMessages;
};
/** @return {object} - get Current Cart grand price */
const getCurrentCartTotal = state => {
  return state.currentCart.total;
};

/** @return {object} - get Current Cart grand price */
const getTotalPriceWithoutDiscountReferrer = state => {
    return state.currentCart.totalWithoutDiscountReferrer;
};

/** @return {object} - get Current Cart tva */
const getCurrentCartTva = state => {
  return state.currentCart.tva;
};

/** @return {object} - get Current Cart grand price */
const getCurrentCartEcoTaxe = state => {
  return state.currentCart.ecoTaxe;
};
/** @return {object} - get Current Cart delivery */
const getCurrentCartDelivery = state => {
  return state.currentCart.delivery;
};
/** @return {object} - get Current Cart essential options */
const getCurrentCartEssentialOptions = state => {
  return state.currentCart.essentialOptions;
};
/** @return {object} - get Current Cart essential options */
const getCurrentCartAdditionalOptions = state => {
  return state.currentCart.additionalOptions;
};
/** @return {object} - get Current Cart essential options */
const getCurrentCartInterventionOptions = state => {
  return state.currentCart.interventionOptions;
};

/** @return {object} - get Current Cart essential options */
const getCurrentCartSchedule = state => {
  return state.currentCart.schedule;
};


/** @return {object} - get Current Cart cgv */
const getCurrentCartCGV = state => {
  return state.currentCart.cgv;
};

/** @return {object} - get Current Cart cgv */
const getCurrentCartCustomerServiceInfo= state => {
  return state.currentCart.customerServiceInfo;
};

/** @return {object} - get Current Cart discount amount */
const getCurrentCartDiscount = state => {
  return state.currentCart.discount;
};

/** @return {object} - get Current Cart discount details */
const getCurrentCartDiscountDetails = state => {
  return state.currentCart.discountDetails;
};

/** @return {object} - get Current Cart discount */
const getCurrentCartCheckoutUrl = state => {
  return state.currentCart.checkoutUrl;
};

const getRentingAmounts = state => {
  return state.currentCart.rentingAmounts;
};

const getCurrentCartTotalItemsCount = state => {
    return state.currentCart.itemsCount;
};

/** @return {object} - get Universign Config */
const getUniversignConfig = state => {
  return state.currentCart.config.universign;
};

/** @return string - current cart universe */
const getCurrentCartUniverse = state => {
  return state.currentCart.mcp_universe;
}

/** @return {object} - get gtm (Google Tag Manager) datas */
const getGtmDatas = state => {
    return state.currentCart.gtmDatas;
};

/** @return {object} - get mainItem in cart*/
const getMainItem = state => {
  return state.currentCart.mainItem
};

/** @return {number} - current cart Qty Total items in cart */
const getCurrentCartTotalItemsQty = state => {
    return state.currentCart.totalItemsQty;
}

/** @return {boolean} -  */
const getInstallationProductInCart = state => {
  return state.currentCart.installationProductInCart;
}

/** @return {boolean} -  */
const getStandardDeliveryInCart = state => {
  return state.currentCart.standardDeliveryInCart;
}

/** @return {boolean} -  */
const getCustomerTaxId = state => {
  return state.currentCart.customerTaxId;
}

/** @return {boolean} -  */
const getTaxHighRate = state => {
  return state.currentCart.taxHighRate;
}

/** @return {boolean} -  */
const getTaxProfils = state => {
  return state.currentCart.taxProfils;
}

export default {
  getCurrentCartProduct,
  getCurrentCartCouponCode,
  getCurrentCartErrorMessages,
  getCurrentCartTotal,
  getCurrentCartDelivery,
  getCurrentCartEssentialOptions,
  getCurrentCartAdditionalOptions,
  getCurrentCartEcoTaxe,
  getCurrentCartSchedule,
  getCurrentCartInterventionOptions,
  getCurrentCartDiscount,
  getCurrentCartDiscountDetails,
  getCurrentCartCGV,
  getCurrentCartTva,
  getCurrentCartCheckoutUrl,
  getRentingAmounts,
  getTotalPriceWithoutDiscountReferrer,
  getCurrentCartTotalItemsCount,
  getUniversignConfig,
  getCurrentCartCustomerServiceInfo,
  getCurrentCartUniverse,
  getGtmDatas,
  getMainItem,
  getCurrentCartTotalItemsQty,
  getInstallationProductInCart,
  getStandardDeliveryInCart,
  getCustomerTaxId,
  getTaxHighRate,
  getTaxProfils
};
